import React, { useState } from 'react';
import { Menu, X, Calculator, Home, BookOpen, Info, Compass } from 'lucide-react';
import logo from '../../logo1.png';

const MobileMenu = ({ isOpen, onClose, onNavigate, currentView }) => {
  const menuItems = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'cgpa', label: 'CGPA Calculator', icon: Calculator },
    { id: 'semester', label: 'Semester GPA', icon: Calculator },
    { id: 'theory', label: 'Theory Subject', icon: BookOpen },
    { id: 'lab', label: 'Lab Subject', icon: BookOpen },
    { id: 'percentage', label: 'Percentage Tools', icon: Calculator },
  ];

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300 lg:hidden ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />
      
      {/* Menu Panel */}
      <div 
        className={`fixed top-0 right-0 h-full w-80 max-w-[85vw] bg-white dark:bg-slate-950 border-l dark:border-slate-800 shadow-2xl z-50 transform transition-transform duration-300 lg:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-slate-200 dark:border-slate-800">
            <div className="flex items-center gap-2">
              <img src={logo} alt="CUCalc Logo" className="w-8 h-8 object-contain" />
              <span className="text-lg font-bold text-slate-900 dark:text-white">CUCalc</span>
            </div>
            <button 
              onClick={onClose}
              className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors"
            >
              <X size={24} className="text-slate-600 dark:text-slate-400" />
            </button>
          </div>

          {/* Menu Items */}
          <nav className="flex-1 overflow-y-auto p-4">
             {/* Community Shortcut */}
             <button
               onClick={() => { onNavigate('campus'); onClose(); }}
               className="w-full flex items-center gap-3 px-4 py-3 mb-4 rounded-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-500/20 active:scale-[0.98] transition-all"
            >
               <Compass size={20} />
               <span>Go to Community</span>
            </button>
            <div className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = currentView === item.id;
                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      onNavigate(item.id);
                      onClose();
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-2xl font-semibold transition-all ${
                      isActive 
                        ? 'bg-indigo-600 dark:bg-indigo-500 text-white shadow-lg' 
                        : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
                    }`}
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </nav>

          {/* Footer */}
          <div className="p-6 border-t border-slate-200 dark:border-slate-800">
            <div className="flex items-start gap-3 text-sm text-slate-500 dark:text-slate-400">
              <Info size={16} className="flex-shrink-0 mt-0.5" />
              <p>COMSATS University GPA Calculator</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
